/**
 * Bestaetigung grosser Optimierungslaeufe (UX-Audit WP5, A2O-09). Ein Klick auf
 * "1.506 Produkte optimieren" startete vorher sofort einen Lauf, der Kontingent
 * belegt und ebenso viele Freigaben in der Werkbank erzeugt. Die Dauer nennt
 * die Rueckfrage bewusst nicht: sie haengt an Menge, Last und Modell und ist
 * nicht gemessen (00-rahmen.md 3.6, keine unbelegten Zahlen).
 */
export const LARGE_RUN_THRESHOLD = 500;

/**
 * `remaining` null = Kapazitaet unbekannt, dann lieber fragen. Belegt der Lauf
 * die ganze Restkapazitaet, fragt `useOptimizationJob` schon mit dem
 * Kontingent-Dialog; eine zweite Rueckfrage direkt davor waere Laerm.
 */
export function needsLargeRunConfirm(target: number, remaining: number | null): boolean {
  if (target < LARGE_RUN_THRESHOLD) return false;
  if (remaining === null) return true;
  return target < remaining;
}
